// src/BaseUrl.js
// ✅ Modern token yapısı + güvenli yönlendirme + tam uyumluluk

import axios from "axios";

// Ortam değişkeninden API URL'sini al
const API_URL = process.env.REACT_APP_API_URL;

// Axios instance oluştur
const api = axios.create({
  baseURL: API_URL,
  withCredentials: true, // Cookie ve cross-site token senaryoları için
  headers: {
    "Content-Type": "application/json",
  },
});

// 🔑 Her istekte token’ı header’a otomatik ekle
api.interceptors.request.use(
  (config) => {
    if (config.data instanceof FormData) {
      delete config.headers["Content-Type"];
    }
    const token =
      localStorage.getItem("@authToken") || localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// 🚫 Token süresi dolmuşsa veya geçersizse
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const message =
      error?.response?.data?.message || error?.response?.data?.msg;

    // Eğer token geçersiz veya süresi dolmuşsa logout
    if (status === 401 || message === "Token is not valid") {
      console.warn("🔒 Token expired — redirecting to login...");

      // Local storage temizle
      localStorage.removeItem("@authToken");
      localStorage.removeItem("token");
      localStorage.removeItem("persist:root");

      // Login sayfasına yönlendir
      window.location.href = "/auth";
    }

    return Promise.reject(error);
  }
);

export default api;
